// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610081135/js/" + chunkId + "." + {"44":"7f356c5d","225":"4e591dbf","481":"f47982ab","486":"7ff0457c","770":"6373bda5"}[chunkId] + ".0.7939392059781626.chunk.js";
};